// export const API_URL = "http://localhost:9100";
export const API_URL = "https://www.tahminmakinesi.com";